import PatientPage from '@/pages/PatientPage/PatientPage.vue'

export default PatientPage
